import { useEffect } from 'react';

const useBodyScrollLock = (isLocked) => {
  useEffect(() => {
    if (isLocked) {
      // Lock the body scroll
      document.body.style.overflow = 'hidden';
    } else {
      // Restore the body scroll
      document.body.style.overflow = 'unset';
    }

    // Cleanup function to restore scroll when component unmounts
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isLocked]);
};

export default useBodyScrollLock;
